module.exports = __webpack_public_path__ + "img/profile-picture-large.0ebcf2e3.png";